import { useMemo } from 'react';

import InteractiveDragDisplay from 'approot/activity-builder/components/shared/interactive-drag-drop/interactive-drag-display';
import {
  InteractiveResponseViewScaler,
  InteractiveResponseTitle,
} from '../../shared/interactive-response-shared';
import {
  RESPONSE_FREE,
  ViewProps,
} from '../interactive-response-categorise.constants';
import { InteractiveDropDisplay } from './interactive-response-categorise-drop-display';
import { InteractiveCategoriseDropItemTarget } from './interactive-response-categorise-drop.style';
import { initialise } from './interactive-response-categorise-play.utils';
import { InteractiveResponsePreviewContainer } from '../../shared/interactive-response-shared.style';
import { getShouldShowNumberOfItemsHint } from '../settings/interactive-response-categorise.utils';
import * as Styled from './interactive-response-categorise.style';

const InteractiveResponseCategoriseStaticPreview = ({
  properties,
}: ViewProps) => {
  const isFreeResponse =
    properties.interactiveResponseCategorise.answerType === RESPONSE_FREE;
  const isShowNumberOfItemsHint = getShouldShowNumberOfItemsHint(
    properties.interactiveResponseCategorise.showNumberOfItemsHint
  );

  const { dragItems, dropItems } = useMemo(() => {
    return initialise({
      items: properties.interactiveResponseCategorise.items,
      categories: properties.interactiveResponseCategorise.categories,
      showAnswer: !isFreeResponse,
      isShowNumberOfItemsHint,
      shouldShuffle: false,
      variant: properties.interactiveResponseCategorise.variant,
    });
  }, [
    isFreeResponse,
    isShowNumberOfItemsHint,
    properties.interactiveResponseCategorise.items,
    properties.interactiveResponseCategorise.categories,
    properties.interactiveResponseCategorise.variant,
  ]);

  return (
    <InteractiveResponseViewScaler
      key={properties.interactiveResponseCategorise.answerType}
    >
      <InteractiveResponseTitle
        title={properties.interactiveResponseCategorise.title}
        subTitle={properties.interactiveResponseCategorise.subTitle}
      />

      <InteractiveResponsePreviewContainer>
        {dragItems.map(dragItem => (
          <Styled.InteractiveResponseCategoryContainerItem key={dragItem.id}>
            <InteractiveDragDisplay
              imageUrl={dragItem.question.image?.small}
              isFit={dragItem.question.image?.isFit}
              description={dragItem.question.image?.description || ''}
              baseColour={dragItem.question.baseColour}
              variant={dragItem.question.variant}
              text={dragItem.question.text}
              richtext={dragItem.question.richtext}
            />
          </Styled.InteractiveResponseCategoryContainerItem>
        ))}
      </InteractiveResponsePreviewContainer>

      <Styled.InteractiveResponseCategories>
        {dropItems.map(dropItem => {
          return (
            <Styled.InteractiveResponseCategory key={dropItem.id}>
              <Styled.InteractiveResponseCategoryLabel>
                {dropItem.label}
              </Styled.InteractiveResponseCategoryLabel>
              <InteractiveCategoriseDropItemTarget>
                {isShowNumberOfItemsHint && (
                  <>
                    {dropItem.zones.map((zone, index) => {
                      return (
                        <InteractiveDropDisplay
                          key={index}
                          hasDropped={false}
                          isContinuousMarking={false}
                        >
                          <div />
                        </InteractiveDropDisplay>
                      );
                    })}
                  </>
                )}
              </InteractiveCategoriseDropItemTarget>
            </Styled.InteractiveResponseCategory>
          );
        })}
      </Styled.InteractiveResponseCategories>
    </InteractiveResponseViewScaler>
  );
};

export default InteractiveResponseCategoriseStaticPreview;
